export default function Safety() {
  const checks = [
    { icon: 'ri-user-star-line', text: 'Informacje o sprzedawcy' },
    { icon: 'ri-image-line', text: 'Zdjęcia QC (kontrola jakości)' },
    { icon: 'ri-chat-3-line', text: 'Opinie użytkowników' },
    { icon: 'ri-bank-card-line', text: 'Metody płatności' },
    { icon: 'ri-truck-line', text: 'Koszty wysyłki' },
  ];

  return (
    <section id="bezpieczenstwo" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <div className="w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20reassuring%20and%20calm%20composition%20featuring%20a%20magnifying%20glass%20inspecting%20a%20product%20package%20next%20to%20a%20smartphone%20showing%20a%20verified%20checkmark%2C%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20daylight%2C%20editorial%20still%20life%20photography%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20conveying%20trust%20security%20and%20careful%20inspection%2C%20professional%20product%20review%20atmosphere%2C%20serene%20and%20confident%20mood&width=800&height=600&seq=kakobuy-safety-v2-01&orientation=landscape"
                alt="Bezpieczeństwo zakupów Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100/70 rounded-full text-xs font-medium text-accent-700 mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-xs"></i>
              </div>
              Bezpieczeństwo
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              Czy Kakobuy jest bezpieczny?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Przed zakupem zawsze warto sprawdzić kilka kluczowych elementów,
              które zapewnią Ci bezpieczną i udaną transakcję.
            </p>

            <div className="space-y-3 mb-8">
              {checks.map((check, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 p-3.5 bg-background-100 rounded-xl border border-background-200/60"
                >
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${check.icon} text-sm text-primary-600`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{check.text}</span>
                </div>
              ))}
            </div>

            <a
              href="/artykul/kakobuy-spreadsheet-kompletny-przewodnik"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-600 hover:bg-primary-700 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Sprawdź poradnik bezpieczeństwa
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}